{
	"title": "Transaktionen hittades inte",
	"description": "Gå till översikten och ange ett giltigt transaktions-ID. Ett transaktions-ID finns på en deklaration eller på en faktura.",
	"secondaryButtonTitle": "Visa startsidan"
}
